import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-card-page',
  templateUrl: './card-page.component.html',
  styleUrls: ['./card-page.component.scss']
})
export class CardPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
